(function (window, undefined) {
    'use strict';

    var app,
        fn = {},
        _fn = {},
        cf = {
            AROUND_DATA_MAX: 10
        },
        timeline,
        map,
        data,
        console,
        appCanvas,
        mapCanvas,
        tlCanvas,
        tlStoryslider,
        appState = {
            position: '',
            width: '',
            height: '',
            top: '',
            left: '',
            zIndex: '',
            overflow: '',
            tl_canvas_height: '',
            tl_storyslider_height: '',
            tl_timenav_height: '',
            tl_tmenubar_top: ''
        },
        isFullscreen = false,
        isResizing = false;

    fn.init = function () {
        console = window.console;
        // console.log('manager.init called.');

        timeline = window.timelinemap.timeline;
        map = window.timelinemap.map;
        data = timeline.getDataAll();

        appCanvas = window.document.getElementById('js-app');

        window.setTimeout(_fn.initFullscreenBtn, 1500);
    };

    fn.onTimelineChange = function (e) {
        var current_id,
            slide,
            ids = [],
            current,
            begin,
            end,
            data_ = [];

        // console.log('onTimelineChange fired.');
        // console.log(data);
        current_id = e.target.current_id;

        // dataが持つオブジェクトのunique_idだけを持つ配列を作成し、current_idのindexを求める
        for (slide in data) {
            ids.push(data[slide].unique_id);
        }

        current = ids.indexOf(current_id);

        if (current !== -1) {
            begin = (current - cf.AROUND_DATA_MAX) > 0 ? current - cf.AROUND_DATA_MAX : 0;
            end = (current + cf.AROUND_DATA_MAX) < data.length ? current + cf.AROUND_DATA_MAX + 1 : data.length + 1;

            // 前後10件のデータオブジェクトを取得し、21件の配列を組み立てる
            data_ = data.slice(begin, end);
        }

        // その配列を引数にしてmapのメソッドを実行
        map.initMarker();
        map.drawMarker(data_, current_id);
    };

    fn.onClickMarker = function (id) {
        timeline.moveTimelineTo(id);
    };

    _fn.initFullscreenBtn = function () {
        var btnFullscreen;

        btnFullscreen = window.document.createElement('div');
        btnFullscreen.setAttribute('class', 'btn-fullscreen');
        btnFullscreen.addEventListener('click', _fn.onFullscreenBtnClick, false);

        appCanvas.appendChild(btnFullscreen);

        appState.position = appCanvas.style.position;
        appState.width    = appCanvas.style.width;
        appState.height   = appCanvas.style.height;
        appState.top      = appCanvas.style.top;
        appState.left     = appCanvas.style.left;
        appState.zIndex   = appCanvas.style.zIndex;
        appState.overflow = window.document.body.style.overflow;

        mapCanvas = window.document.getElementById('js-map-canvas');
        tlCanvas = window.document.getElementById('timeline');
        appState.tl_canvas_height = tlCanvas.style.height;

        tlStoryslider = tlCanvas.querySelector('.tl-storyslider');

        btnFullscreen.style.display = 'block';

        window.addEventListener('resize', _fn.onWindowResized, false);
    };

    _fn.onFullscreenBtnClick = function (e) {
        if (isFullscreen) {
            _fn.exitFullscreen();
        } else {
            _fn.enterFullscreen();
        }
    };

    _fn.onWindowResized = function () {
        if (isFullscreen) {
            if (isResizing !== false) {
                window.clearTimeout(isResizing);
            }
            isResizing = window.setTimeout(function () {
                var center;
                center = map.getCenter();

                mapCanvas.style.height = tlStoryslider.style.height;
                map.resize(center, isFullscreen);
            }, 200);
        }
    };

    _fn.enterFullscreen = function () {
        var center;

        // console.log('enterFullscreen');

        center = map.getCenter();

        appCanvas.style.position = 'fixed';
        appCanvas.style.width    = '100%';
        appCanvas.style.height   = '100%';
        appCanvas.style.top      = '0';
        appCanvas.style.left     = '0';
        appCanvas.style.zIndex   = '300';

        tlCanvas.style.height      = '100%';

        window.document.body.style.overflow = 'hidden';

        isFullscreen = true;

        timeline.updateDisplay();

        mapCanvas.style.height = tlStoryslider.style.height;
        map.resize(center, isFullscreen);
    };

    _fn.exitFullscreen = function () {
        var center;

        // console.log('exitFullscreen');

        center = map.getCenter();

        if (appState.position === '') {
            appCanvas.style.position = 'relative';
        } else {
            appCanvas.style.position = appState.position;
        }
        appCanvas.style.width  = appState.width;
        appCanvas.style.height = appState.height;
        appCanvas.style.top    = appState.top;
        appCanvas.style.left   = appState.left;
        appCanvas.style.zIndex = appState.zIndex;

        tlCanvas.style.height = appState.tl_canvas_height;

        window.document.body.style.overflow = appState.overflow;

        isFullscreen = false;

        timeline.updateDisplay();

        mapCanvas.style.height = tlStoryslider.style.height;
        map.resize(center, isFullscreen);
    };

    app = function (prop) {
        var app,
            m;

        app = {};
        for (m in fn) {
            app[m] = fn[m];
        }
        return app;
    };

    window.timelinemap = window.timelinemap || {};
    window.timelinemap.fn = window.timelinemap.fn || {};
    window.timelinemap.fn.manager = app;

}(this));
